const TYPE_SUCCESS = 'success';
const TYPE_ERROR = 'danger';

export default function AlertService() {
    Object.assign(this, {
        success,
        error,
        clear,
        getAlerts,
    });

    const alerts = [];

    function success(message) {
        clear();
        createAlert(message, TYPE_SUCCESS);
    }

    function error(message) {
        clear();
        createAlert(message, TYPE_ERROR);
    }

    function getAlerts() {
        return alerts;
    }

    function createAlert(msg, type) {
        return alerts.push({
            visible: true,
            type,
            msg,
            hide: clear,
        });
    }

    function clear() {
        alerts.splice(0, alerts.length);
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/message-alert/alert-service.js